/**
 * The BlogPosts List container
 */
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { actions as blogPostsActions } from "../../redux/blogposts";
import { push } from "connected-react-router";
// import {setLanguage} from "redux-i18n";
import Page from "../../components/Page";
import { Link } from "react-router-dom";
import { Row, Col, Container, ListGroupItem, ListGroup } from "reactstrap";
import ShopProductCard from "../../components/ShopProductCard";
import ResponsivePicture from "../../components/ResponsivePicture";
import LazyLoad from "react-lazyload";
import { useSsrEffect } from "@issr/core";
import BreadcrumbBar from "../../components/Utilities/BreadcrumbBar/BreadcrumbBar";

/**
 * Selects props from the store and passes them to the component
 * @param {Object} state the store
 */
const mapStateToProps = (state) => ({
  blogpost: state.blogPosts.show,
  loadingShow: state.blogPosts.loadingShow,
  loadedShow: state.blogPosts.loadedShow,
  showError: state.blogPosts.showError,
  language: state.i18nState.lang,
});
/**
 * Binds dispatch method to the actions passed as props to the component
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showBlogPost: blogPostsActions.show,
      navigateTo: push,
    },
    dispatch
  );

/**
 * The `index` container to show a list of blogPosts
 * Both the component and the connected component are exported for testing purpose.
 * If storing resources is activated, this page will show a list of stored blogPosts when offline
 */
const BlogPost = (props, context) => {
  const blogPostSlug = props.match ? props.match.params.slug : false;
  const {
    loadingShow,
    blogpost,
    language,
    showError,
    navigateTo,
    showBlogPost,
  } = props;

  /**
   * Frontload function called before component mounts to
   * prefetch the list of blogPosts
   */
  const frontload = async () => {
    if (
      (!blogpost ||
        (blogpost &&
          (blogpost.language !== language ||
            blogpost.slug !== blogPostSlug))) &&
      !loadingShow &&
      !(showError && showError.slug === blogPostSlug)
    ) {
      showBlogPost(blogPostSlug);
    } else if (!loadingShow && showError && showError.slug === blogPostSlug) {
      navigateTo(`/${language}/blog/`);
    }
  };

  useSsrEffect(frontload, [
    blogPostSlug,
    showError,
    loadingShow,
    showBlogPost,
    blogpost,
    navigateTo,
    language,
  ]);

  // /** navigates to the show blogPost page if user has permission */
  // const handleShowBlogPost = (blogPost_id, event) => {
  //   navigateTo(`/${language}/blogposts/${blogPost_id}/`);
  // };

  return (
    <Page
      id="blogPost"
      pageType="blog"
      title={blogpost ? blogpost.title : false}
      lang={language}
      description={blogpost ? blogpost.content_preview : false}
    >
      <BreadcrumbBar
        items={[
          {
            link: `/${language}/blog/`,
            title: context.t("Blog"),
          },
        ]}
        current={blogpost ? { title: blogpost?.title } : false}
      />
      {!blogpost && <span>loading...</span>}
      {blogpost && (
        <Container className="my-2">
          <Row>
            {/* sizes="(min-width: 87.5em) calc(466.66px - 30px),(min-width: 75em) calc(33.33vw - 30px), (min-width: 62em) calc(360px - 30px), (min-width: 48em) calc(540px - 30px), (min-width: 36em) calc(100vw - 30px)" */}

            <Col lg={8} className="pb-5">
              {blogpost.hero_image && (
                <LazyLoad>
                  <ResponsivePicture
                    className="card-img-top"
                    sources={blogpost.hero_image}
                    alt={blogpost.title}
                  />
                </LazyLoad>
              )}

              <h1 className="h3 mt-3">{blogpost.title}</h1>
              {blogpost.content_preview && (
                <p className="pb-3">{blogpost.content_preview}</p>
              )}
              <div dangerouslySetInnerHTML={{ __html: blogpost.content }} />
            </Col>
            <Col lg={4}>
              <ListGroup>
                <ListGroupItem>
                  <h2 className="h6">
                    {context.t("Inspiration, creative ideas and tutorials")}
                  </h2>
                  <p>
                    {context.t(
                      "In our blog we provide tips and tricks on the subject of adhesive films, stickers and advertising technology."
                    )}
                  </p>
                  <Link to={`/de/blog/`}>{context.t("view all posts")}</Link>
                </ListGroupItem>
                {blogpost.related_blog_posts &&
                  blogpost.related_blog_posts.length > 0 && (
                    <ListGroupItem>
                      <h3 className="h6">{context.t("Related Posts")}</h3>
                      <ul className="list-unstyled">
                        {blogpost.related_blog_posts.map((post) => (
                          <li className="mb-2">
                            <Link to={`/${language}/blog/${post.slug}/`}>
                              {post.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </ListGroupItem>
                  )}
                {blogpost.related_products && (
                  <ListGroupItem>
                    <h3 className="h6">{context.t("Related Products")}</h3>
                    <Row>
                      {blogpost.related_products.data &&
                        blogpost.related_products.data.map((product, idx) => {
                          // FIXME what if image is not set?
                          if (
                            product.relationships &&
                            product.relationships.images.data.length > 0
                          ) {
                            if (blogpost.related_products.included) {
                              product = {
                                ...product,
                                thumbnail: {
                                  img_url:
                                    blogpost.related_products.included.filter(
                                      (incl) => {
                                        return (
                                          incl.type === "image" &&
                                          incl.id ===
                                            product.relationships.images.data[0]
                                              .id
                                        );
                                      }
                                    )[0].attributes.styles[2].url,
                                },
                              };
                            }
                          }
                          return (
                            <Col
                              key={`product-${idx}`}
                              md={6}
                              lg={12}
                              xl={6}
                              className="mb-3"
                            >
                              <ShopProductCard
                                product={product}
                                language={language}
                                navigateTo={navigateTo}
                                titleTag="h2"
                              />
                            </Col>
                          );
                        })}
                    </Row>
                  </ListGroupItem>
                )}
              </ListGroup>
            </Col>
          </Row>
        </Container>
      )}
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
BlogPost.contextTypes = {
  t: PropTypes.func,
};

/** export the redux connected component and add a frontload call */
export default connect(mapStateToProps, mapDispatchToProps)(BlogPost);
